import request from '../../../core/wrappers/axios-wrapper';
import { StoreManagerPermissionQuery } from '../../../types/constants/apiUrls/storeManagerPermission/storeManagerPermissionQuery';
import { RequestType } from '../../../types/enums/request-enums';

const inFlightRequests = new Map<string, Promise<any>>();

const runWithDedup = (key: string, factory: () => Promise<any>): Promise<any> => {
    const existing = inFlightRequests.get(key);
    if (existing) {
        return existing;
    }

    const promise = factory().finally(() => {
        inFlightRequests.delete(key);
    });
    inFlightRequests.set(key, promise);
    return promise;
};

// FeatureKey / StoreCode query'de yok; BFF token + header'dan çözer
const GetStaff = (): Promise<any> =>
    runWithDedup('store-manager-permission:staff', () =>
        request({
            url: StoreManagerPermissionQuery.Staff,
            method: RequestType.GET,
        })
    );

const GetHistory = (params: { PageNumber?: number; PageSize?: number; TargetApplicationUserId?: number }): Promise<any> =>
    runWithDedup(`store-manager-permission:history:${JSON.stringify(params ?? {})}`, () =>
        request({
            url: StoreManagerPermissionQuery.History,
            method: RequestType.GET,
            params: params,
        })
    );

const StoreManagerPermissionQueryService = {
    GetStaff,
    GetHistory,
};

export default StoreManagerPermissionQueryService;
